import { observable, action, computed } from 'mobx'
import { IStaff } from '@/model/types/staff'

class AccountFilterStore {
    @observable
    staffIds: IStaff[] = []

    @observable
    scene: Array<{
        name: string
        id: number
    }> = []

    @observable
    refresh: boolean = false

    @computed
    get filterText() {
        const filterArr = []
        if (this.staffIds.length) {
            filterArr.push(this.staffIds.map(s => s.user.realname).join('、'))
        }
        if (this.scene.length === 1) {
            filterArr.push(this.scene[0].name)
        }

        return filterArr.join('、')
    }

    @action
    reset() {
        this.staffIds = []
        this.scene = []
    }

    @computed
    get filterQuery() {
        return {
            scenes: this.scene.length ? this.scene.map(s => s.id) : [0, 1],
            cashier_staff_ids: this.staffIds.length ? this.staffIds.map(s => s.id) : void 0,
        }
    }

    @action
    setScene(
        s: Array<{
            name: string
            id: number
        }>,
    ) {
        this.scene = s
    }

    @action setSatff(staff: IStaff[]) {
        this.staffIds = staff
    }
}

export const accountFilterStore = new AccountFilterStore()
